if (!customElements.get('newsletter-form')) {
  customElements.define(
    'newsletter-form',
    class NewsletterForm extends HTMLElement {
      constructor() {
        super();
        this.submitting = false;
        this.onSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.button = this.form.querySelector('[type="submit"]');
        this.spinner = this.form.querySelector('.loading__spinner');
        this.form.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      }

      onSubmit() {
        if (this.submitting) return;
        this.submitting = true;
        this.form.setAttribute('aria-busy', 'true');
        if (this.button) {
          this.button.classList.add('loading');
          this.button.setAttribute('aria-disabled', 'true');
        }
        if (this.spinner) this.spinner.classList.remove('hidden');
      }
    }
  );
}
